<template>
  <div>
    <table class='confirmation-table'>
      <tr>
        <td>{{ 'report-of-sickness.first-of-absence' | translate }}</td>
        <td v-if="this.editReportOfSickness.firstOfAbsence === this.reportOfSickness.firstOfAbsence">
          {{getFormattedDate(editReportOfSickness.firstOfAbsence)}}
        </td>
        <td v-else>
          <p class="diff">{{getFormattedDate(this.reportOfSickness.firstOfAbsence)}}</p>
          {{getFormattedDate(editReportOfSickness.firstOfAbsence)}}
        </td>
      </tr>

      <tr>
        <td>{{ 'report-of-sickness.disability-rate' | translate }}</td>
        <td v-if="editReportOfSickness.disabilityRate === reportOfSickness.disabilityRate">
          {{editReportOfSickness.disabilityRate}}%
        </td>
        <td v-else>
          <p class="diff">{{reportOfSickness.disabilityRate}}%</p>
          {{editReportOfSickness.disabilityRate}}%
        </td>
      </tr>

      <tr>
        <td>{{ 'report-of-sickness.safetynet' | translate }}</td>
        <td v-if="editReportOfSickness.safetyNet === reportOfSickness.safetyNet">
          {{getSafetyNetText(editReportOfSickness.safetyNet)}}
        </td>
        <td v-else>
          <p class="diff">{{getSafetyNetText(reportOfSickness.safetyNet)}}</p>
          {{getSafetyNetText(editReportOfSickness.safetyNet)}}
        </td>
      </tr>

      <tr>
        <td>{{ 'report-of-sickness.accident' | translate }}</td>
        <td v-if="editReportOfSickness.accident === reportOfSickness.accident">
          {{getAccidentText(editReportOfSickness.accident)}}
        </td>
        <td v-else>
          <p class="diff">{{getAccidentText(reportOfSickness.accident)}}</p>
          {{getAccidentText(editReportOfSickness.accident)}}
        </td>
      </tr>
      <tr v-if="editReportOfSickness.accident === true">
        <td>{{ 'report-of-sickness.third-party-liability' | translate }}</td>
        <td v-if="editReportOfSickness.thirdPartyLiability === reportOfSickness.thirdPartyLiability">
          {{getThirdPartyLiabilityText(editReportOfSickness.thirdPartyLiability)}}
        </td>
        <td v-else>
          <p class="diff">{{getThirdPartyLiabilityText(reportOfSickness.thirdPartyLiability)}}</p>
          {{getThirdPartyLiabilityText(editReportOfSickness.thirdPartyLiability)}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HelperFunctions from '@/shared/helpers/functions';

export default {
  name: 'EditReportOfSicknessConfirmationBox',
  props: {
    reportOfSickness: Object
  },
  methods: {
    getSafetyNetText (value) {
      if (value === true) return this.$t('report-of-sickness.form.yes-safetynet');
      else if (value === false) return this.$t('report-of-sickness.form.no-safetynet');
      else return this.$t('forms.no-entry');
    },
    getAccidentText (value) {
      if (value === true) return this.$t('report-of-sickness.form.yes-accident');
      else if (value === false) return this.$t('report-of-sickness.form.no-accident');
      else return this.$t('forms.no-entry');
    },
    getThirdPartyLiabilityText (value) {
      if (value === true) return this.$t('report-of-sickness.form.yes-third-party-liability');
      else if (value === false) return this.$t('report-of-sickness.form.no-third-party-liability');
      else return this.$t('forms.no-entry');
    },
    getFormattedDate (value) {
      return HelperFunctions.Dates.formatDate(value);
    }
  },
  computed: {
    editReportOfSickness () {
      return this.$store.getters.editReportOfSickness;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.diff {
  color: $error-lighten-3;
  text-decoration: line-through;
}

.confirmation-row {
  border-bottom: 1px solid $gray;

  &.no-border {
    border: 0;

    td {
      padding-bottom: 0px;
    }
  }
}

.question {
  color: $primary-lighten-1;
}

.answer {
  color: $primary;
  font-weight: 500;
  font-size: 1.2em;

  p {
    &.diff {
      color: $error-lighten-3;
      text-decoration: line-through;
    }
  }
}

table {
  border-collapse: collapse;
  width: 100%;
}

table > tr {
  vertical-align: top;
  padding: 10px 0px;
  border-bottom: 1px solid $gray;
}

td {
  padding: 20px 0px;

  &:first-child {
    padding-right: 20px;
  }
}
</style>
